import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';

import LoginPage from './Pages/LoginPageComponent.js';
import SurveyForm from './Pages/SurveyFormComponent.tsx';
import SurveyRecording from './Pages/SurveyRecordingComponent.tsx';
import FavoriteButterflies from './Pages/FavoriteButterfliesComponent.tsx';
import MainMenu from './Pages/MainMenuComponent.js';
import SettingsPage from './Pages/SettingsPageComponent.js';
import SurveySummary from './Pages/SurveySummaryComponent.tsx';
import AdminPage from './Pages/AdminPageComponent.js';
import AnalyticsPage from './Pages/AnalyticsPageComponent.tsx';
import RecentSurveys from './Pages/RecentSurveysComponent.tsx';
import ExportPage from './Pages/ExportPageComponent.tsx';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/menu" element={<MainMenu />} />
        <Route path="/favorites" element={<FavoriteButterflies />} />
        <Route path="/survey" element={<SurveyForm />}/>
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/recording" element={<SurveyRecording />} />
        <Route path="/summary" element={<SurveySummary />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/surveys" element={<RecentSurveys />} />
        <Route path="/export" element={<ExportPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
